import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';
import { SettingsFeatureState } from '../interfaces/settings-feature-state.interface';
import { getDebug, getTag } from '../utils/debugUtil';
import { accountingBasesReducer, createSelectors as accountingBasisCreateSelectors } from './accounting-basis.reducer';
import { createSelectors as currencyCreateSelectors, currencyReducer } from './currency.reducer';
import {
    createSelectors as financialLineItemsCreateSelectors,
    financialLineItemsReducer,
} from './financial-line-item.reducer';
import { createSelectors as legalFormsCreateSelectors, legalFormsReducer } from './legal-form.reducer';
import { createSelectors as translationSelectors, translationsReducer } from './translations.reducer';

const filename = 'projects/aumico-lib-settings-fe/src/lib/reducers/settings-root.reducer.ts';
const debug = getDebug(filename);
const TAG = getTag(filename);

export const settingsFeatureKey = 'aumicoSettingsMicroservice';

// Selectors Declarations - END
// ROOT
// Feature
const selectRootSettingsFeature = createFeatureSelector<SettingsFeatureState>(settingsFeatureKey);

// Sub feature
const selectAccountingBasisState = createSelector(selectRootSettingsFeature, (state) => state.accountingBasis);
export const accountingBasisStateSelectors = accountingBasisCreateSelectors(selectAccountingBasisState);

const selectLegalFormState = createSelector(selectRootSettingsFeature, (state) => state.legalForm);
export const legalFormStateSelectors = legalFormsCreateSelectors(selectLegalFormState);

const selectFinancialLineItemState = createSelector(selectRootSettingsFeature, (state) => state.financialLineItem);
export const financialLineItemStateSelectors = financialLineItemsCreateSelectors(selectFinancialLineItemState);

const selectCurrencyState = createSelector(selectRootSettingsFeature, (state) => state.currency);
export const currencyStateSelectors = currencyCreateSelectors(selectCurrencyState);

const selectTranslationsState = createSelector(selectRootSettingsFeature, (state) => state.translations);
export const translationsStateSelectors = translationSelectors(selectTranslationsState);

// Reducer Declarations - START
export const reducers: ActionReducerMap<SettingsFeatureState> = {
    accountingBasis: accountingBasesReducer,
    legalForm: legalFormsReducer,
    financialLineItem: financialLineItemsReducer,
    currency: currencyReducer,
    translations: translationsReducer,
};
